import axios from './axios';

function generateFileWithId(schoolId) {
  return new File([JSON.stringify({ schoolId })], 'id.json', {
    type: 'application/json',
    lastModified: new Date(),
  });
}
export const importUserData = schoolId => axios.post('/mis/import', { schoolId });

export const importRoutes = schoolId => axios.post('/transportation/routes/import', { schoolId });

export const extractUserData = schoolId => axios.post('/mis/extract', { schoolId });

export const extractRoutes = (schoolId, format) =>
  axios.post(`/transportation/routes/extract${format ? `?format=${format}` : ''}`, { schoolId });

export const exportUserData = schoolId => axios.post('/mis/export', { schoolId });

export const exportRoutes = (schoolId, format) =>
  axios.post(`/transportation/routes/export${format ? `?format=${format}` : ''}`, { schoolId });

export const getRoutesExportFormats = () =>
  axios.get('/transportation/routes/export/formats');

export const uploadUsersFile = ({ binary, schoolId }) => {
  const formData = new FormData();
  formData.append('binary', binary);
  formData.append('metadata', generateFileWithId(schoolId));
  return axios.post('/mis/upload', formData);
};

export const uploadRoutesFile = ({ binary, schoolId }) => {
  const formData = new FormData();
  formData.append('binary', binary);
  formData.append('metadata', generateFileWithId(schoolId));
  return axios.post('/transportation/routes/upload', formData);
};

export const importEcaEvents = schoolId => axios.post('/eca/import', { schoolId });

export const extractEcaEvents = schoolId => axios.post('/eca/extract', { schoolId });

export const exportEcaEvents = schoolId => axios.post('/eca/export', { schoolId });

export const uploadEcaEventsFile = ({ binary, schoolId }) => {
  const formData = new FormData();
  formData.append('binary', binary);
  formData.append('metadata', generateFileWithId(schoolId));
  return axios.post('/eca/upload', formData);
};
